import './modules/WebSdk'
import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import CreateMembership from './components/membership/CreateMembership/CreateMembership'
import Events from './components/Events'
import EventDetails from './components/EventDetails'
import EditMember from './components/EditMember'
import EditMembership from './components/EditMembership'
import MemberList from './components/MemberList'
import BulkUpload from './components/BulkUpload'

import './custom.css'
import MembersEvents from './components/MembersEvents';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
        <AuthorizeRoute exact path='/' component={Home} />
        <AuthorizeRoute exact path='/new-member' component={CreateMembership} />
        <AuthorizeRoute exact path='/events' component={Events} />
        <AuthorizeRoute path='/eventDetails/:eventId' component={EventDetails} />
        <AuthorizeRoute path='/editMember/:memberId' component={EditMember} />
        <AuthorizeRoute path='/editMembership/:membershipId' component={EditMembership} />
        <AuthorizeRoute path='/membersevents/:memberId' component={MembersEvents} />
        <AuthorizeRoute path='/memberlist' component={MemberList} />
        <AuthorizeRoute path='/bulkUpload' component={BulkUpload} />
        <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
      </Layout>
    );
  }
}
